import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Image, Button, Card, Badge } from "react-bootstrap";
import RatingStar from "../../common/ratingStar/ratingStar";
import { MESSAGE } from "../../../utils/message";
import { useNavigate } from "react-router-dom";
import NoImage from "../../../assests/images/gnp_noimg.png";
import Top_rated_icon from "../../../assests/images/top-rated-icon.svg";
import {
    CardCamp,
    CardImageBody,
    CardRating,
    CardTextBody,
    CardBadge,
    ImageBadge,
    TopRatedImage,
    TopRatedText,
    CardImageButton,
    SeeMoreResultButton,
} from "./campCardStyle";
import { CategoryProps, NonprofitProps } from "../../../utils/types";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {  campDetailHandler } from "../../../redux/slices/donationCamp/campDetail-slice";
import { showErrorToast } from "../../../utils/toast";
interface Props {
    donationCampData: NonprofitProps[]
    setPageNumber?: (val: number | ((prevCount: number) => number)) => void;
    nonProfitLoader?: boolean;
    count?: number
}
const CampCard = ({ donationCampData, setPageNumber, count }: Props) => {
    const navigate = useNavigate();
    const dispatch: any = useDispatch();

    const availableModules = useSelector((state: any) => state?.modules?.data?.results);
    const isLoading: boolean = useSelector(
        (state: any) => state?.nonprofits?.isLoading
    );

   const handleSeeMore = () => {
        if (setPageNumber) {
            setPageNumber((prevCount: number) => prevCount + 1);
        }
    };
 

    const handleTitleClick = async (slug: string) => {
        const result = await dispatch(campDetailHandler(slug));

        if (result?.status === 200 && result?.results?.slug) {
            navigate(`/org/${result?.results?.slug}`);
        } else if (result?.status === 404) {
            showErrorToast(result?.message || "Organization not Found");
        } else {
            showErrorToast("Something went wrong. Please try again.");
        }
    };



    return (
        <>
            {donationCampData?.map((donationCamp: NonprofitProps, index: number) => (
                <CardCamp as={Col} sm="12" md="6" lg="4" key={index + 1}>

                    <Card>
                        <CardImageBody className="img-card">
                            <Card.Img src={donationCamp?.image ? donationCamp?.image : NoImage} />
                            {donationCamp?.topRatedText && <ImageBadge>
                                <TopRatedImage>
                                    <Image src={Top_rated_icon} alt="Top Rated Icon" width="20" height="20" />
                                </TopRatedImage>
                                <TopRatedText>{donationCamp?.topRatedText}</TopRatedText>
                            </ImageBadge>}
                            {availableModules?.donation && donationCamp?.is_donation_enable && <CardImageButton className="card-donate-btn">
                                <Button onClick={() => navigate(`/org/${donationCamp?.slug}`, { state: { isDonate: true } })} className="donate-now-btn">{MESSAGE.donateNowBtn}</Button>
                            </CardImageButton>}
                        </CardImageBody>

                        <CardTextBody className="ch">
                            <Card.Body>
                                <Card.Title onClick={() => handleTitleClick(donationCamp?.slug)}>{donationCamp?.title}</Card.Title>
                                <CardRating> <RatingStar review={donationCamp?.reviews} rating={donationCamp?.rating} /></CardRating>
                                <Card.Text>{donationCamp?.address}</Card.Text>
                                <CardBadge>
                                    {donationCamp?.category?.length > 6 ? (
                                        <>
                                            {donationCamp.category.slice(0, 6).map((category: CategoryProps, index: number) => (
                                                <Badge key={index + 1}>{category.name}</Badge>
                                            ))}
                                            <Button
                                                variant="link"
                                                className="view-more-btn"

                                                onClick={() => {
                                                    navigate(`/org/${donationCamp?.slug}`)
                                                }}
                                            >
                                                View More
                                            </Button>
                                        </>
                                    ) : (
                                        donationCamp?.category?.map((category: CategoryProps, index: number) => (
                                            <Badge key={index + 1}>{category.name}</Badge>
                                        ))
                                    )}
                                </CardBadge>
                            </Card.Body>
                        </CardTextBody>
                    </Card>
                </CardCamp>
            ))}
            {count && count > 9 ? (
                <SeeMoreResultButton className="SeeMoreBtn">
                    <Button className="btn-outline-success-blue see-more-btn" onClick={handleSeeMore}>
                        {MESSAGE.seeMoreButtonText}{isLoading && (<span className="btnloader"></span>)}
                    </Button>
                </SeeMoreResultButton>
            ) : (
                <></>
            )}

        </>
    )
};
export default CampCard;